import{paletteV2 as e}from"../palette/palette.js";const t={defaultProps:{variantMapping:{label:"label"}},styleOverrides:{root:{color:e.grey900.main}}};export{t as MuiTypographyV2};
//# sourceMappingURL=MuiTypographyV2.js.map
